import React from 'react';
import { connect } from 'react-redux'; import axios from 'axios';
import { ROOT_API_URL } from '../../../../../api-config';
import { auth, userService } from '../../../../../services';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Input } from '@progress/kendo-react-inputs';
import { getPaymentTypes } from '../../../../../Redux/Actions/CommonActions';

import IsLoading from '../../../../Shared/Loading/IsLoading';
import SpanSpinner from '../../../../Shared/SpanSpinner/SpanSpinner';

class EditForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            openBatches: [],
            tranName: this.props.transactionData.Name || '',
            tranPaymentTypeId: this.props.transactionData.PaymentTypeId || 0,
            tranAmount: Number(this.props.transactionData.Amount) || 0,
            tranPaymentType: {
                name: this.props.transactionData.Description || "Credit",
                id: this.props.transactionData.PaymentTypeId || 1
            },
            isLoading: false
        }
    }

    componentDidMount() {
        this.props.getPaymentTypes();
        axios.get(`${ROOT_API_URL}/ManageBatches/GetOpenBatches?paymentTypeId=${this.props.transactionData.PaymentTypeId}`, { headers: auth.authHeader() })
            .then((response) => {
                const batches = response.data;

                if (batches.length) {

                    for (var i = 0; i < batches.length; i++) {
                        if (!batches[i].batchName) {
                            batches[i].batchName = batches[i].batchJobId;
                        }
                    }
                }

                this.setState({
                    openBatches: batches,
                    SelectedBatch: {
                        batchName: this.props.transactionData.BatchName || this.props.transactionData.BatchJobId,
                        batchJobId: this.props.transactionData.BatchJobId
                    },
                    SelectedBatchId: this.props.transactionData.BatchJobId
                });
            });
    }

    handleBatchChange = (event) => {
        this.setState({
            SelectedBatch: event.target.value,
            SelectedBatchId: event.target.value.batchJobId
        })
    }

    handleTextChange = ({ target }) => {
        this.setState({ [target.name]: target.value });
    };


    handlePaymentChange = (event) => {
        this.setState({
            tranPaymentType: event.target.value,
            tranPaymentTypeId: event.target.value.id,
            SelectedBatch: null,
            SelectedBatchId: null
        })

        axios.get(
            `${ROOT_API_URL}/ManageBatches/GetOpenBatches?paymentTypeId=${event.target.value.id}`,
            {
                headers: auth.authHeader()
            }
        ).then((response) => {
            const batches = response.data;

            if (batches.length) {

                for (var i = 0; i < batches.length; i++) {
                    if (!batches[i].batchName) {
                        batches[i].batchName = batches[i].batchJobId;
                    }
                }

                this.setState({
                    openBatches: batches
                });
            }
        });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        this.setState({
            isLoading: true
        })

        axios.post(`${ROOT_API_URL}/ManageTransaction/UpdateTransactionBatch`, {
            BatchJobId: this.state.SelectedBatchId,
            TransactionId: this.props.transactionData.TransactionId,
            Name: this.state.tranName,
            PaymentTypeId: this.state.tranPaymentType.id,
            Amount: Number(this.state.tranAmount)
        }, { headers: auth.authHeader() })
            .then((response) => {
                this.setState({
                    isLoading: false
                })
                this.props.refreshGird();
                this.props.cancel();
            });
    };

    render() {
        return (
            <form className="" onSubmit={this.handleSubmit}>
                
                <div className="purchaseAndRenewals">
                    <h1>Edit Transaction</h1>
                    <div className="row">
                        <div className="form-group col-md-12 col-lg-6">
                            <label htmlFor="tranName">Name</label>

                            <Input
                                required={true}
                                type="text"
                                name="tranName"
                                value={this.state.tranName}
                                onChange={this.handleTextChange}
                                id="tranName"
                                minLength={1}
                            />
                        </div>
                        <div className="form-group col-md-12 col-lg-6">
                            <label htmlFor="totalAmount">Total Amount</label>
                            <Input
                                required={true}
                                type="text"
                                name="tranAmount"
                                value={this.state.tranAmount}
                                onChange={this.handleTextChange}
                                id="tranAmount"
                                minLength={1}
                                pattern={"[0-9]+(\\.[0-9][0-9]?)?"}
                                placeholder="1234.00"
                            />
                        </div>
                        <div className="form-group col-md-12 col-lg-6">
                            <label htmlFor="paymentType">Payment Type</label>
                            <DropDownList data={this.props.common.paymentTypes}
                                required={true}
                                id="paymentTypeId"
                                name="name"
                                textField="name"
                                dataItemKey="id"
                                onChange={this.handlePaymentChange}
                                value={this.state.tranPaymentType}
                                width={300}
                            />
                        </div>
                        <div className="form-group col-md-12  col-lg-6">
                            <label htmlFor="openBatche">Select Batch</label>
                            <DropDownList data={this.state.openBatches}
                                required={true}
                                textField="batchName"
                                dataItemKey="batchJobId"
                                onChange={this.handleBatchChange}
                                value={this.state.SelectedBatch}
                                width={300}
                            />
                        </div>
                    </div>
                </div>
                <div className="footer">
                    <div className="form-group">

                        {this.state.isLoading ? 
                            (<button disabled id="transactionSpanSpinnerContainer" className="admin-k-button">
                                <SpanSpinner message="Saving..." />
                            </button>) :
                            (<button type="submit" className="admin-k-button">
                                <i className="fas fa-save"></i>
                                <span> SAVE</span>
                            </button>)
                        }
                        <button className="admin-k-button" onClick={() => this.props.cancel()}>
                            <i className="fas fa-times"></i>
                            <span> CANCEL</span>
                        </button>
                    </div>
                </div>
            </form>
        )
    }
}

//function mapStateToProps(state) {
//    return {
//        purchaseAndRenewals: state.purchaseAndRenewals
//    };
//}

function mapStateToProps(state) {
    return {
        //purchaseAndRenewals: state.purchaseAndRenewals,
        common: state.common
    };
}

export default connect(mapStateToProps, {
    getPaymentTypes
})(EditForm);